import type {FC} from 'react'
import {Box, Skeleton} from '@mui/material'

/** A question on the right, an answer on the left: the shape a chat loads into. */
const TURNS: {question: string; answerLines: string[]}[] = [
  {question: '55%', answerLines: ['92%', '80%', '64%']},
  {question: '40%', answerLines: ['88%', '70%']},
]

interface Props {
  /** Read out instead of the shapes, e.g. "Loading conversation…". */
  label: string
}

/**
 * Stands in for a conversation while its first page loads (opening or
 * switching to it), in the layout of the bubbles it is replaced by, so the
 * panel does not jump when the messages arrive.
 */
const ChatSkeleton: FC<Props> = ({label}) => (
  <Box
    role="status"
    aria-busy="true"
    aria-label={label}
    data-testid="alpinist-chat-skeleton"
    sx={{display: 'flex', flexDirection: 'column', gap: 1.5, px: 1, pt: 1.5}}
  >
    {TURNS.map((turn, i) => (
      <Box key={i} sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
        <Skeleton
          variant="rounded"
          height={36}
          sx={{alignSelf: 'flex-end', width: turn.question, borderRadius: 2}}
        />
        <Box sx={{borderRadius: 2, p: 1, bgcolor: 'primary.second'}}>
          {turn.answerLines.map((width, j) => (
            <Skeleton key={j} variant="text" sx={{width, fontSize: '0.95rem'}} />
          ))}
        </Box>
      </Box>
    ))}
  </Box>
)

export default ChatSkeleton
